class DocumentStatusConstants {
  static readonly DRAFT = 'Draft';
  static readonly READY = 'Ready';
  static readonly CLAIM_WAITING_FOR_PPS_SCORING = 'Waiting for PPS Scoring';
  static readonly CLAIM_WAITING_FOR_GLOBAL_MARKETING_CONTENT_APPROVAL = 'Waiting for Global Marketing Content approval';
  static readonly CLAIM_REVIEW_APPROVED = 'Approved';
  static readonly CLAIM_REVIEW_REJECTED = 'Rejected';
}

export default DocumentStatusConstants;
